export default {
  namespaced: true,
  state: {
    pageSizeOptions: ['20', '50', '100']
  },
  getters: {
  },
  mutations: {},
  actions: {}
}
